/** Label for languages spoken on profile cards. */
export function getLanguageSpokenLabel(
  lang: string | undefined,
  t: (key: string) => string,
  useFullLabels = false
): string | null {
  if (!lang) return null;

  if (useFullLabels) {
    if (lang === "en") return t("common.speaks_english");
    if (lang === "es" || lang === "both") return t("common.speaks_english_and_spanish");
    return null;
  }

  if (lang === "en") return t("common.speaks_compact_en");
  if (lang === "es" || lang === "both") return t("common.speaks_compact_both");
  return null;
}
